import clsx from "clsx";
import type { ProjectStatusBadgeProps } from "../projectCard.types";
import { PROJECT_STATUS_CONFIG, getStatusIcon } from "../projectCard.definitions";

export function ProjectStatusBadge({ status }: ProjectStatusBadgeProps) {
  const StatusIcon = getStatusIcon(status);

  return (
    <div className="inline-flex items-center space-x-1.5">
      <StatusIcon className="w-3.5 h-3.5" />
      <span
        className={clsx(
          "px-2.5 py-1 rounded-full font-medium text-xs tracking-wide",
          PROJECT_STATUS_CONFIG[status].color
        )}
      >
        {PROJECT_STATUS_CONFIG[status].label}
      </span>
    </div>
  );
}